<script>
export const pageName = 'map';
export const pageRoute = '/model-achievement-programme';
export const title = 'Model Achievement Programme'
export const requireAuth = false

import { getLevelName } from '../../../functions/domain/map/map.js';
import { getCurrentUserId } from '../../js/auth.js';
import { listenToMapScoreboard, listenToUserView } from '../../js/readModel.js';
import { getUserMap } from '../../js/utils/map.js';
import MapFlightCardUrl from '../../resources/MAP-and-Record-flight-card-A4-v3-1.pdf'

export default {
	data() {
		return {
			currentUser: null,
			data: null,
			scoreboard: null,
			backgrounds: {},
			MapFlightCardUrl,
			ready: false
		}
	},

	methods: {
		getLevelName,
		async boot(opts) {

			// allow anon visitors from main website
			if(getCurrentUserId())
			{
				await listenToUserView(getCurrentUserId(), async user => {
					this.currentUser = user;
					this.data = await getUserMap(this.currentUser);
				});
			}
			else
			{
				this.data = await getUserMap(null);
			}

			await listenToMapScoreboard(scoreboard => this.scoreboard = scoreboard);

			this.ready = true;
		}
	}
}

</script>
<template>
	<div v-if="ready" class="container py-5">
		<h1 class="display-4 text-center mb-3">Model Achievement Programme</h1>
		<p class="text-muted text-center mb-3">The Model Achievement Programme is a fantastic opportunity to develop your skills as a rocket modeller by completing a series of increasingly difficult and complicated challenges. Please see <a href="https://ukra.org.uk/certification/model-achievement-programme/" target="_blank">the main UKRA website <span class="fe fe-external-link"></span></a> for a full description of the programme.</p>
		<p class="text-muted text-center mb-5"><a :href="MapFlightCardUrl" target="_blank">Download the MAP Flight Card <span class="fe fe-download"></span></a> for use in the field.</p>

		<p class="alert alert-light mb-4"><span class="fe fe-info"></span> Looking for where to submit MAP flights? <a href="/rockets">Add a rocket</a> to the Flight Logger to get started.</p>

		<p class="alert alert-light mb-5"><span class="fe fe-info"></span> View a list of <a href="/model-achievement-programme/assessors">active MAP Assessors</a> to help you find one at a club meet.</p>

		<h1 class="mb-4 text-center">Leader board</h1>
		<div class="row">
			<div class="col-12 col-md-6">
				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">XP</h4>
					</div>
					<div class="card-body">
						<div class="list-group list-group-flush my-n3">
							<div v-for="(xper, index) in scoreboard.xpScoreboard" :class="`list-group-item ${index >= 5 ? 'd-none d-md-block' : ''}`">
								<div class="row align-items-center">
									<div class="col-auto">
										<span class="display-4">{{ index + 1}}</span>
									</div>	
									<div class="col-auto">
										<div class="avatar avatar-sm">
											<img class="avatar-img rounded-circle" :src="xper.userAvatar">
										</div>
									</div>
									<div class="col">
										<h4 class="mb-1">{{ xper.userName }}</h4>
										<small class="text-muted">{{ xper.xp  }} XP, {{ getLevelName(xper.level) }}</small>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-12 col-md-6">
				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">Hydrazine</h4>
					</div>
					<div class="card-body">
						<div class="list-group list-group-flush my-n3">
							<div v-for="(xper, index) in scoreboard.hydrazineScoreboard" :class="`list-group-item ${index >= 5 ? 'd-none d-md-block' : ''}`">
								<div class="row align-items-center">
									<div class="col-auto">
										<span class="display-4">{{ index + 1}}</span>
									</div>	
									<div class="col-auto">
										<div class="avatar avatar-sm">
											<img class="avatar-img rounded-circle" :src="xper.userAvatar">
										</div>
									</div>
									<div class="col">
										<h4 class="mb-1">{{ xper.userName }}</h4>
										<small class="text-muted">{{ xper.hydrazine  }} Hydrazine, {{ getLevelName(xper.level) }}</small>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="text-center">
			<hr class="my-5">
			<h1 class="mb-2">Bonuses</h1>
			<p class="text-muted mb-4">Unlock these tasks by earning Hydrazine.</p>
			<div v-if="currentUser" class="row align-items-center mb-2">
				<div class="col pr-0">
					<div class="progress">
						<div class="progress-bar" role="progressbar" :style="`width: ${data.bonuses.filter(b => b.complete).length * 100 / data.bonuses.length}%`"></div>
					</div>
				</div>
				<div class="col-auto">
					Bonuses {{ (data.bonuses.filter(b => b.complete).length * 100 / data.bonuses.length).toFixed(0) }}% completed
				</div>
			</div>
			<div v-if="currentUser" class="row align-items-center mb-5">
				<div class="col pr-0">
					<div class="progress">
						<div class="progress-bar bg-danger" role="progressbar" :style="`width: ${Math.min(100, currentUser.map.hydrazine * 100 / data.hydrazineRequired)}%`"></div>
					</div>
				</div>
				<div class="col-auto">
					{{ (data.hydrazineRequired - currentUser.map.hydrazine) }} Hydrazine to next bonus
				</div>
			</div>
			<div class="row">
				<div v-for="task in data.bonuses" class="col-6 col-md-4 col-lg-3">
					<a v-if="task.unlocked" :href="`/model-achievement-programme/task/${encodeURIComponent(task.id)}`" class="card card-fill card-fill-top">
						<div class="card-body">
							<div class="d-inline-block" :style="`background: url(${task.bg});}`">
								<img :src="task.icon" />
							</div>
							<h2 class="text-body">{{ task.name }}</h2>
							<div class="text-muted">{{ task.desc }}</div>
							<span v-if="task.xp && !task.complete" :class="`badge badge-white border border-1 shadow font-weight-bold`" style="position: absolute; top: -5px; right: -5px; font-size: 90%">+{{ task.xp }} XP</span>
							<span v-if="task.xp && task.complete" :class="`badge badge-success border border-1 shadow font-weight-bold`" style="position: absolute; top: -5px; right: -5px; font-size: 90%">Completed</span>
							<span v-if="task.hydrazine" :class="`badge badge-soft-danger shadow font-weight-bold`" style="position: absolute; top: -5px; right: -5px; font-size: 90%">+{{ task.hydrazine }} Hydrazine</span>
						</div>
					</a>
					<a v-else class="card card-fill card-fill-top">
						<div class="card-body">
							<div class="d-inline-block" :style="`background: url(${task.bg});}`">
								<img :src="task.icon" />
							</div>
							<h2 class="text-body">Locked</h2>
							<div class="text-muted">Earn Hydrazine to unlock this task</div>
							<span class="badge badge-soft-danger shadow font-weight-bold" style="position: absolute; top: -5px; right: -5px; font-size: 90%">{{ task.requiredHydrazine }} Hydrazine required</span>
						</div>
					</a>
				</div>
			</div>
		</div>
		<div class="text-center" v-for="(level, i) in data.levels">
			<hr class="my-5">
			<h1 class="mb-2">{{ level.name }}</h1>
			<div v-if="!currentUser">
				<p v-if="level.xpRequired" class="text-muted mb-4">You need {{ level.xpRequired }} XP to graduate from this rank.</p>
				<p v-else class="text-muted mb-4">This is the highest rank within MAP.</p>
			</div>
			<div v-else-if="level.xpRequired < currentUser?.map.xp" class="mb-5">
				<p class="text-muted mb-4">You have graduated from this rank but may still repeat Hydrazine tasks or complete any missing tasks.</p>
				
				<div class="row align-items-center">
					<div class="col pr-0">
						<div class="progress">
							<div class="progress-bar" role="progressbar" :style="`width: ${level.percentComplete}%`"></div>
						</div>
					</div>
					<div class="col-auto">
						Rank {{ level.percentComplete.toFixed(0) }}% completed
					</div>
				</div>
			</div>
			<div v-else-if="level.id == currentUser?.map.level" class="mb-5">
				<span class="badge badge-primary shadow font-weight-bold mb-2">Your current rank</span>
				<p v-if="level.xpRequired" class="text-muted mb-4">You need {{ level.xpRequired - currentUser.map.xp }} XP more to graduate from this rank.</p>
				<p v-else class="text-muted mb-4">This is the highest rank within MAP.</p>
				<div class="row align-items-center">
					<div class="col pr-0">
						<div class="progress">
							<div class="progress-bar" role="progressbar" :style="`width: ${Math.min(level.percentComplete, 100)}%`"></div>
						</div>
					</div>
					<div class="col-auto">
						Rank {{ Math.min(level.percentComplete, 100).toFixed(0) }}% completed
					</div>
				</div>
				<div v-if="level.xpRequired" class="row align-items-center">
					<div class="col pr-0">
						<div class="progress">
							<div class="progress-bar" role="progressbar" :style="`width: ${Math.min(currentUser.map.xp * 100 / level.xpRequired, 100)}%`"></div>
						</div>
					</div>
					<div class="col-auto">
						{{ level.xpRequired - currentUser.map.xp }} XP to graduate
					</div>
				</div>
				
			</div>
			<div v-else class="mb-5">
				<p v-if="level.xpRequired" class="text-muted mb-4">You need {{ level.xpRequired }} XP to graduate from this rank.</p>
				<p v-else class="text-muted mb-4">This is the highest rank within MAP.</p>
				<div class="row align-items-center">
					<div class="col pr-0">
						<div class="progress">
							<div class="progress-bar" role="progressbar"></div>
						</div>
					</div>
					<div class="col-auto">
						Rank 0% completed
					</div>
				</div>
			</div>
			<div class="row">
				<template v-for="subject of data.levels[i].subjects">
					<template v-if="subject.tasks.length">
						<div v-for="task in subject.tasks" class="col-6 col-md-4 col-lg-3">
							<a :href="`/model-achievement-programme/task/${encodeURIComponent(task.id)}`" class="card card-fill card-fill-top">
								<div class="card-body">
									<div class="d-inline-block" :style="`background: url(${task.bg}); ${task.mode == 'future' ? 'opacity: 0.5' : ''}`">
										<img :src="task.icon" />
									</div>
									<h2 :class="`${task.mode == 'future' ? 'text-muted' : 'text-body'}`">{{ task.name }}</h2>
									<div class="text-muted">{{ task.desc }}</div>
									<span v-if="task.xp !== undefined && !task.complete" :class="`badge ${task.special ? 'badge-primary' : 'badge-white text-primary'} border border-1 shadow font-weight-bold`" style="position: absolute; top: -5px; right: -5px; font-size: 90%">+{{ task.xp }} XP{{ task.special ? ' ' + task.special : null }}</span>
									<span v-if="task.xp !== undefined && task.complete" :class="`badge badge-success border border-1 shadow font-weight-bold`" style="position: absolute; top: -5px; right: -5px; font-size: 90%">Completed</span>
									<span v-if="task.hydrazine" :class="`badge ${task.special || task.complete ? 'badge-danger' : 'badge-white text-danger'} shadow font-weight-bold`" style="position: absolute; top: -5px; right: -5px; font-size: 90%">+{{ task.hydrazine }} Hydrazine{{ task.special ? ' ' + task.special : null }}</span>
								</div>
							</a>
						</div>
					</template>
				</template>
			</div>
		</div>
    </div>
</template>
